import { Component, computed, Input, OnInit, signal, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { PageTitleService } from '@app/services/page-title/page-title.service';
import { PlatformService } from '@app/services/platform/platform.service';
import { Logger, LoggingService } from 'ionic-logging-service';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class HeaderComponent implements OnInit {

  @Input() iconName: string;
  @Input() menuToggleRight: boolean;
  @Input() showErrorMessageNetwork: boolean;

  currentTitle = computed(() => this.pageTitleService.pageTitle());
  public currentUrl = signal<string>('');
  public back: any;
  public show_header = true;
  public isIOS: boolean     = this.platformService.isIOS();
  public isAndroid: boolean     = this.platformService.isAndroid();
  private logger: Logger;


  constructor(
    private loggingService: LoggingService,
    private pageTitleService: PageTitleService,
    private platformService: PlatformService,
    private titleService: Title,
    private router: Router,
  ) {
    this.logger = loggingService.getLogger("[HeaderComponent]");
    const methodName = "ctor";
    this.logger.entry(methodName);
  }

  ngOnInit() {
    this.logger.info('HeaderComponent ngOnInit()');
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.currentUrl.set(event.urlAfterRedirects.split('?')[0]);
      // this.titleService.setTitle(this.currentTitle()); // browser tab title
      // let route = this.activatedRoute;
      // while (route.firstChild) route = route.firstChild;
      // const pageTitle = route.snapshot.data['title'];
      // if (pageTitle) {
      //   this.currentTitle = pageTitle;         // header title
      // }
    });
  }
}
